import api from "./api";

export default class TransferApi {
  static postTransferSolicitation = async (obj: any, code: any) => {
    const response = await api.post(`/Transferencias`, obj, {
      headers: {
        codigo: code,
      },
    });
    return response.data;
    // console.log("obj", obj)
  };

  static getTransferSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    minValue: number,
    maxValue: number
  ) => {
    const response = await api.get(
      `/Transferencias?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}&dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&valorInicio=${minValue}&valorFim=${maxValue}`
    );
    return response;
  };

  static getTransferPerId = async (idTransfer: any) => {
    const response = await api.get(`/Transferencias/${idTransfer}`);
    return response.data;
  };

  static deleteTransferPerId = async (id: number) => {
    const response = await api.delete(`/Transferencias/${id}`);
    return response.data;
  };

  static exportTransferencia = async (
    idStatus: any,
    valorInicio: any,
    valorFim: any,
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string
  ) => {
    const response = await api.get(
      `/Transferencias/exportacao/download?idStatus=${idStatus}&idCliente=${id}&dataInicio=${dataInicio}&dataFim=${dataFim}&valorInicio=${valorInicio}&valorFim=${valorFim}&Search=${search}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
}
